import React, { useEffect, useState } from 'react';
import "./AboutCompany.css";
import TheStar from "../Assets/star.svg";
import { supabase } from "../supabaseClient";

const AboutCompany = () => {
  const [description, setDescription] = useState("");
  const [imageUrl, setImageUrl] = useState("");

  useEffect(() => {
    const getData = async () => {
      const res = await supabase.from("AboutThree").select("*");
      if (res.data && res.data.length > 0) {
        setDescription(res.data[0].description);
        setImageUrl(res.data[0].image_url ?? "");
      }
    };
    getData();
  }, []);

  return (
    <>
      <h2 className="titly">About Company</h2>
      <img src={TheStar} className="deco" alt="about tilion" />
      <div className="companion">
        {imageUrl && <img src={imageUrl} alt="tilion" />}
        <p className="comtext">{description}</p>
      </div>
    </>
  );
};

export default AboutCompany;